import { firebaseConfig } from '@/z-shared/config/firebase';

const urlFirebaseConfig = new URLSearchParams(firebaseConfig);
// toDo: хочется переместить в папку /service-workers, но боюсь, что тогда активные воркеры отрубятся.
// попробовать разобраться как заменить url активных воркеров
const swUrl = `/firebase-messaging-sw.js?${urlFirebaseConfig}`;
const workerScope = '/firebase-push-notification-scope';

export const getOrRegisterServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
    try {
        return window
            .navigator
            .serviceWorker
            .getRegistration(workerScope)
            .then(async serviceWorker => {
                if (serviceWorker) return serviceWorker;
                return window.navigator.serviceWorker.register(
                    swUrl,
                    {
                        scope: workerScope,
                        updateViaCache: 'none',
                    },
                );
            });
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
    }
    return Promise.resolve(null);
};
